module.exports = __webpack_public_path__ + "img/aliPay.75a827b7.png";